<div class="col-12 d-none d-md-flex justify-content-between align-items-center" *ngIf="internalSettings">

  <div class="font18 inline-block">
    <span class="align-middle font-header-login-details align-items-center d-flex gap-1">{{ 'SI_NAVBAR_WELCOME' | translate}},
      {{ translate.getCustomerName(this.internalSettings) }}
      <app-personal-finance-management-header></app-personal-finance-management-header>
      <app-voice-command-header></app-voice-command-header> 
    </span>

  </div>

  <div class="font14 ml-auto inline-block">
    <span class="align-middle font-header-login-details align-items-center">{{ 'LABEL_LAST_LOGIN' | translate }}:
      {{this.internalSettings.profile.dateAndTimeLastLogin }}
    </span>
  </div>

</div>

<div class="col-12 d-md-none sidebar-nav-switch">
  <mat-icon (click)="toggleSidebar()" svgIcon="farBars" class="icon-white cursor-pointer"></mat-icon>
</div>